import { TrackerEventType } from "src/core/model/TrackerEventType";
import { TrackerVariableType } from "src/core/model/TrackerVariableType";

import { EventListener } from "./EventListener";
import { NativeEventTrigger } from "./PageViewListener";

/**
 * Listens for visibility change events (tab focus/blur).
 * Mirrors Android AppStateListener.
 */
export class VisibilityListener implements EventListener {
  private trigger: NativeEventTrigger;
  private started = false;
  private boundHandler: (() => void) | null = null;

  constructor(trigger: NativeEventTrigger) {
    this.trigger = trigger;
  }

  start(): void {
    if (this.started) return;
    this.started = true;

    this.boundHandler = () => this.trigger(TrackerEventType.VISIBILITY_CHANGE);
    document.addEventListener("visibilitychange", this.boundHandler);
  }

  stop(): void {
    if (!this.started) return;
    this.started = false;

    if (this.boundHandler) {
      document.removeEventListener("visibilitychange", this.boundHandler);
      this.boundHandler = null;
    }
  }

  getTypes(): TrackerEventType[] {
    return [TrackerEventType.VISIBILITY_CHANGE];
  }

  getVariableTypes(): TrackerVariableType[] {
    return [TrackerVariableType.VIEW_DURATION];
  }
}
